import { useNotNullableContext } from './useNotNullableContext';
import { PageMetaContext } from '../context/PageMetaContext';
import { generateUrlWithShareParameter } from '../utils/generateUrlWithShareParameter';
import generateHash from '../utils/generateHash';
import { captureException } from '@sentry/browser';

interface SocialShareProps {
  ogImageUrl?: string | null;
  ogDescription?: string | null;
}

export function useSocialShare({
  ogImageUrl,
  ogDescription,
}: SocialShareProps = {}) {
  const { currentUrl, pageType, pageShortName } = useNotNullableContext(
    PageMetaContext,
  );

  const shareUrl = generateUrlWithShareParameter(
    currentUrl,
    {
      ogDescription: ogDescription ?? '',
      ogImageUrl: ogImageUrl?.split('?')[0] ?? '',
    },
    true,
  );

  const shareOnFacebook = () =>
    FB.ui(
      {
        method: 'share',
        href: `${shareUrl}utm_source=facebook&utm_medium=${pageType}&utm_content=${pageShortName}&utm_campaign=pfp-share&utm_term=${generateHash()}`,
      },
      response => {
        if (response && (response.error_message || response.error_code)) {
          captureException({
            facebookErrorCode: response.error_code,
            facebookErrorMessage: response.error_message,
          });
        }
      },
    );

  return { shareUrl, shareOnFacebook };
}
